import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CoreDirectivesModule } from '@core/directives/directives';
import { CorePipesModule } from '@core/pipes/pipes.module';
import {
  NgbDropdownModule,
  NgbModule,
  NgbPaginationModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ConfirmDialogModule } from 'app/layout/components/confirm-dialog/confirm-dialog.module';
import { ErrorMsgModule } from 'app/layout/components/error-msg/error-msg.module';
import { NgxMaskModule } from 'ngx-mask';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { UppercaseDirective } from './../../../@core/directives/uppercase.directive';
import { AutoFocus } from './autofocus.directive';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { PasswordComponent } from './components/password-strength/password.component';
import { ScrollTopComponent } from './components/scroll-top/scroll-top.component';
import { TableListAbstractComponent } from './components/table-list-abstract/table-list-abstract.component';
import { TableHeaderFilterComponent } from './components/table/table-header-filter/table-header-filter.component';
import { TableTitleComponent } from './components/table/table-title/table-title.component';
import { DocLinkComponent } from './components/doc-link/doc-link.component';
import { CreateVacationScheduleModalComponent } from './corporate/modals/create-vacation-schedule-modal/create-vacation-schedule-modal.component';
import { VacationsScheduleModalListComponent } from './corporate/modals/vacations-schedule-modal-list/vacations-schedule-modal-list.component';
import { AdmissionFormBaseComponent } from './hiring/admission-form-base/admission-form-base.component';
import { OcrSourceIconComponent } from './hiring/admission-form-base/ocr-source-icon/ocr-source-icon.component';
import { AppSharedDrawerWorkforceplanSolicitationComponent } from './components/drawer-workforce-plan-solicitation/workforce-plan-drawer-team-solicitation.component';
import { CostCenterChangeFormComponent } from './components/drawer-workforce-plan-solicitation/solicitation-forms/cost-center-change-form/cost-center-change-form.component';
import { DismissalFormComponent } from './components/drawer-workforce-plan-solicitation/solicitation-forms/dismissal-form/dismissal-form.component';
import { InternalTrainingFormComponent } from './components/drawer-workforce-plan-solicitation/solicitation-forms/internal-training-form/internal-training-form.component';
import { PromotionFormComponent } from './components/drawer-workforce-plan-solicitation/solicitation-forms/promotion-form/promotion-form.component';
import { SalaryRangeSelectComponent } from './components/drawer-workforce-plan-solicitation/solicitation-forms/salary-range-select/salary-range-select.component';
import { EmployeeInfoDisplayComponent } from './components/employee-info-display/employee-info-display.component';
import { WorkforcePlanDrawerEmployeeService } from 'services/workforceplan/workforceplan-employee.service';
import { AppSharedActionRequiredListComponent } from './components/list-action-required/action-required-list.component';
import { WorkforceplanService } from 'services/workforceplan/workforceplan-main.service';
import { ActionRequiredService } from 'services/action-required/action-required.service';
import { AppSharedDrawerWorkforceplanSolicitationPlanningComponent } from './components/drawer-workforce-plan-solicitation-planning/drawer-workforce-plan-solicitation-planning.component';
import { WeatherComponent } from '../pages/home/weather/weather.component';
import { CustomDangerButton } from './components/custom-danger-button/custom-danger-button.component';
import { AppSharedDrawerComponent } from './components/dynamic-drawer/dynamic-drawer.component';
import { WizardComponent } from './components/wizard/wizard.component';
import { AppDropzoneFilesComponent } from './components/dropzone-files/dropzone-files.component';
import { DateRangePickerComponent } from './components/date-ranger-picker/date-ranger-picker.component';
import { FormBuilderGroupComponent } from './components/form-builder/form-builder-group/form-builder-group.component';
import { FormBuilderQuestionManageDrawerComponent } from './components/form-builder/form-builder-question-manage-drawer/form-builder-question-manage-drawer.component';
import { FormDebugComponent } from './components/form-builder/form-debug/form-debug.component';
import { FormAnswersComponent } from './components/form-builder/form-builder-answer/form-answer/form-answer.component';
import { FormSubmissionComponent } from './components/form-builder/form-builder-answer/form-submission/form-submission.component';
import { FormBuilderAnswerComponent } from './components/form-builder/form-builder-answer/form-section-answer/form-section-answer.component';
import { FormInputRadioComponent } from './components/form-builder/form-builder-answer/form-section-answer/components/form-input-radio/form-input-radio.component';
import { FormInputSelectComponent } from './components/form-builder/form-builder-answer/form-section-answer/components/form-input-select/form-input-select.component';
import { FormInputMultiselectComponent } from './components/form-builder/form-builder-answer/form-section-answer/components/form-input-multiselect/form-input-multiselect.component';
import { FormInputTextareaComponent } from './components/form-builder/form-builder-answer/form-section-answer/components/form-input-textarea/form-input-textarea.component';
import { FormInputTextComponent } from './components/form-builder/form-builder-answer/form-section-answer/components/form-input-text/form-input-text.component';
import { FormInputDateComponent } from './components/form-builder/form-builder-answer/form-section-answer/components/form-input-date/form-input-date.component';
import { FormInputFileComponent } from './components/form-builder/form-builder-answer/form-section-answer/components/form-input-file/form-input-file.component';
import { UploadFileInputComponent } from './components/upload-file-input/upload-file-input.component';
import { HiringConfigFormComponent } from "./hiring/hiring-config-form/hiring-config-form.component";

import { DragDropModule } from '@angular/cdk/drag-drop';
import { NouisliderModule } from 'ng2-nouislider';
import { SliderComponent } from './components/slider/slider.component';
import { EmployeeSelectComponent } from './components/employee-select/employee-select.component';
import { JobReferralLinkDialogComponent } from './components/job-referral-link-dialog/job-referral-link-dialog.component';

import { FeedbackFormComponent } from './feedback/components/feedback-form/feedback-form.component';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ReceivedFeedbackListComponent } from './feedback/components/received-feedback-list/received-feedback-list.component';
import { SentFeedbackListComponent } from './feedback/components/sent-feedback-list/sent-feedback-list.component';
import { EmployeeDetailsFeedbacksComponent } from './feedback/components/employee-details-feedbacks/employee-details-feedbacks.component';
import { EmployeeDetailsSalaryHistoryComponent } from './components/employee-details-salary-history/employee-details-salary-history.component';
import { EmployeeDetailsDisciplinaryMeasureComponent } from './components/employee-details-disciplinary-measure/employee-details-disciplinary-measure.component';
import { ManagerHierarchyComponent } from '../pages/home/manager-hierarchy/manager-hierarchy.component';
import { DropdownActionsComponent } from './components/dropdown-actions/dropdown-actions.component';
import { PreHandlingTimeInfoDrawerComponent } from '../pages/corporate/employees-management/modals/pre-handling-time-info-drawer/pre-handling-time-info-drawer.component';
import { PreHandlingInfoModalComponent } from '../pages/corporate/employees-management/modals/pre-handling-info-modal/pre-handling-info-modal.component';
import { CreateExcusedAbsenceModalComponent } from '../pages/corporate/employees-management/modals/create-excused-absence/create-excused-absence.component';
import { ConfigurableTitleComponent } from './components/configurable-title/configurable-title.component';
import { ConfigurableDescriptionComponent } from './components/configurable-description/configurable-description.component';
import { ConfigurableCoverComponent } from './components/configurable-cover/configurable-cover.component';
import { KanbanBoardComponent } from './components/kanban/kanban-board.component';
import { KanbanFilterPipe } from './components/kanban/pipes/kanban-filter.pipe';
import { SocialIconsComponent } from './components/social-icons/social-icons.component';
import { PageFooterComponent } from './components/page-footer/page-footer.component';
import { WorkforceplanMovementRequestService } from 'services/workforceplan/workforceplan-movement-request.service';
import { ApprovalScopeService } from 'services/corporate/approval-scope.service';
import { MediaEditorModalComponent } from './components/media-editor-modal/media-editor-modal.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ActionPlanFormListComponent } from './components/action-plan/action-plan-form-list/action-plan-form-list.component';
import { TreatActionPlanDrawerComponent } from './components/action-plan/treat-action-plan-drawer/treat-action-plan-drawer.component';
import { ActionPlanTypeDatatableComponent } from './components/action-plan/action-plan-type-datatable/action-plan-type-datatable.component';
import { ActionPlanTypeManageDrawerComponent } from './components/action-plan/action-plan-type-manage-drawer/action-plan-type-manage-drawer.component';
import { ApprovalScopeOpeningInstructionsBannerComponent } from './components/approval-scope-opening-instructions-banner/approval-scope-opening-instructions-banner.component';
import { SankeyChartComponent } from './components/sankey-chart/sankey-chart.component';
import { LangflowChatDrawerComponent } from './components/langflow-chat-drawer/langflow-chat-drawer.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { FormMetricsDashboardComponent } from './components/form-builder/form-metrics/form-metrics-dashboard/form-metrics-dashboard.component';
import { FormMetricsGroupSectionComponent } from './components/form-builder/form-metrics/form-metrics-group-section/form-metrics-group-section.component';
import { FormMetricsItemWidgetComponent } from './components/form-builder/form-metrics/form-metrics-item-widget/form-metrics-item-widget.component';
import { FormMetricsCommentsModalComponent } from './components/form-builder/form-metrics/form-metrics-comments-modal/form-metrics-comments-modal.component';
import { FormMetricsPieWidgetComponent } from './components/form-builder/form-metrics/widgets/form-metrics-pie-widget/form-metrics-pie-widget.component';
import { FormMetricsBarWidgetComponent } from './components/form-builder/form-metrics/widgets/form-metrics-bar-widget/form-metrics-bar-widget.component';
import { FormMetricsThermometerWidgetComponent } from './components/form-builder/form-metrics/widgets/form-metrics-thermometer-widget/form-metrics-thermometer-widget.component';
import { FormMetricsBinaryThermometerWidgetComponent } from './components/form-builder/form-metrics/widgets/form-metrics-binary-thermometer-widget/form-metrics-binary-thermometer-widget.component';
import { FormMetricsCommentsWidgetComponent } from './components/form-builder/form-metrics/widgets/form-metrics-comments-widget/form-metrics-comments-widget.component';
import { FormMetricsTemporalWidgetComponent } from './components/form-builder/form-metrics/widgets/form-metrics-temporal-widget/form-metrics-temporal-widget.component';
import { FormMetricsChartLegendComponent } from './components/form-builder/form-metrics/form-metrics-chart-legend/form-metrics-chart-legend.component';
import { TacticalDimensionTableComponent } from './components/tactical-dimension-table/tactical-dimension-table.component';

@NgModule({
  providers: [
    WorkforceplanService,
    ActionRequiredService,
    WorkforcePlanDrawerEmployeeService,
    WorkforceplanMovementRequestService,
    ApprovalScopeService,
  ],
  imports: [
    NgbPaginationModule,
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbDropdownModule,
    NgbModule,
    ConfirmDialogModule,
    ErrorMsgModule,
    NgSelectModule,
    PerfectScrollbarModule,
    NgxMaskModule.forRoot(),
    CoreDirectivesModule,
    CorePipesModule,
    DragDropModule,
    NgbTooltipModule,
    NouisliderModule,
    NgxDatatableModule,
    ImageCropperModule,
    NgApexchartsModule,
  ],
  declarations: [
    AdmissionFormBaseComponent,
    OcrSourceIconComponent,
    MediaEditorModalComponent,
    HiringConfigFormComponent,
    TableListAbstractComponent,
    TableTitleComponent,
    DocLinkComponent,
    UppercaseDirective,
    PasswordComponent,
    TableHeaderFilterComponent,
    PaginatorComponent,
    FormDebugComponent,
    AutoFocus,
    VacationsScheduleModalListComponent,
    CreateVacationScheduleModalComponent,
    ScrollTopComponent,
    AppSharedDrawerWorkforceplanSolicitationComponent,
    CostCenterChangeFormComponent,
    DismissalFormComponent,
    InternalTrainingFormComponent,
    PromotionFormComponent,
    SalaryRangeSelectComponent,
    EmployeeInfoDisplayComponent,
    AppSharedActionRequiredListComponent,
    AppSharedDrawerWorkforceplanSolicitationPlanningComponent,
    WeatherComponent,
    CustomDangerButton,
    AppSharedDrawerComponent,
    PreHandlingTimeInfoDrawerComponent,
    PreHandlingInfoModalComponent,
    CreateExcusedAbsenceModalComponent,
    FormBuilderAnswerComponent,
    FormInputRadioComponent,
    FormInputSelectComponent,
    FormInputMultiselectComponent,
    FormInputTextareaComponent,
    FormInputTextComponent,
    FormInputDateComponent,
    FormInputFileComponent,
    DateRangePickerComponent,
    WizardComponent,
    AppDropzoneFilesComponent,
    FormBuilderGroupComponent,
    FormBuilderQuestionManageDrawerComponent,
    FormAnswersComponent,
    FormSubmissionComponent,
    UploadFileInputComponent,
    SliderComponent,
    EmployeeSelectComponent,
    JobReferralLinkDialogComponent,
    UploadFileInputComponent,
    FeedbackFormComponent,
    ReceivedFeedbackListComponent,
    SentFeedbackListComponent,
    EmployeeDetailsFeedbacksComponent,
    EmployeeDetailsSalaryHistoryComponent,
    EmployeeDetailsDisciplinaryMeasureComponent,
    ManagerHierarchyComponent,
    DropdownActionsComponent,
    ConfigurableTitleComponent,
    ConfigurableDescriptionComponent,
    ConfigurableCoverComponent,
    KanbanBoardComponent,
    KanbanFilterPipe,
    SocialIconsComponent,
    PageFooterComponent,
    ActionPlanFormListComponent,
    TreatActionPlanDrawerComponent,
    ActionPlanTypeDatatableComponent,
    ActionPlanTypeManageDrawerComponent,
    ApprovalScopeOpeningInstructionsBannerComponent,
    SankeyChartComponent,
    LangflowChatDrawerComponent,
    FormMetricsDashboardComponent,
    FormMetricsGroupSectionComponent,
    FormMetricsItemWidgetComponent,
    FormMetricsCommentsModalComponent,
    FormMetricsPieWidgetComponent,
    FormMetricsBarWidgetComponent,
    FormMetricsThermometerWidgetComponent,
    FormMetricsBinaryThermometerWidgetComponent,
    FormMetricsCommentsWidgetComponent,
    FormMetricsTemporalWidgetComponent,
    FormMetricsChartLegendComponent,
    TacticalDimensionTableComponent,
  ],
  exports: [
    AdmissionFormBaseComponent,
    HiringConfigFormComponent,
    TableListAbstractComponent,
    TableTitleComponent,
    DocLinkComponent,
    TableHeaderFilterComponent,
    PasswordComponent,
    UppercaseDirective,
    PaginatorComponent,
    FormDebugComponent,
    NgSelectModule,
    NgxMaskModule,
    AutoFocus,
    VacationsScheduleModalListComponent,
    ScrollTopComponent,
    AppSharedDrawerWorkforceplanSolicitationComponent,
    CostCenterChangeFormComponent,
    DismissalFormComponent,
    InternalTrainingFormComponent,
    PromotionFormComponent,
    EmployeeInfoDisplayComponent,
    AppSharedActionRequiredListComponent,
    AppSharedDrawerWorkforceplanSolicitationPlanningComponent,
    WeatherComponent,
    CustomDangerButton,
    AppSharedDrawerComponent,
    PreHandlingTimeInfoDrawerComponent,
    PreHandlingInfoModalComponent,
    CreateExcusedAbsenceModalComponent,
    FormBuilderAnswerComponent,
    FormInputRadioComponent,
    FormInputSelectComponent,
    FormInputMultiselectComponent,
    FormInputTextareaComponent,
    FormInputTextComponent,
    FormInputDateComponent,
    FormInputFileComponent,
    DateRangePickerComponent,
    WizardComponent,
    AppDropzoneFilesComponent,
    FormBuilderGroupComponent,
    FormBuilderQuestionManageDrawerComponent,
    FormAnswersComponent,
    FormSubmissionComponent,
    UploadFileInputComponent,
    SliderComponent,
    EmployeeSelectComponent,
    JobReferralLinkDialogComponent,
    FeedbackFormComponent,
    ReceivedFeedbackListComponent,
    SentFeedbackListComponent,
    EmployeeDetailsFeedbacksComponent,
    EmployeeDetailsSalaryHistoryComponent,
    EmployeeDetailsDisciplinaryMeasureComponent,
    ManagerHierarchyComponent,
    DropdownActionsComponent,
    ConfigurableTitleComponent,
    ConfigurableDescriptionComponent,
    ConfigurableCoverComponent,
    KanbanBoardComponent,
    KanbanFilterPipe,
    SocialIconsComponent,
    PageFooterComponent,
    ActionPlanFormListComponent,
    NgxDatatableModule,
    TreatActionPlanDrawerComponent,
    ActionPlanTypeDatatableComponent,
    ActionPlanTypeManageDrawerComponent,
    ApprovalScopeOpeningInstructionsBannerComponent,
    SankeyChartComponent,
    LangflowChatDrawerComponent,
    FormMetricsDashboardComponent,
    FormMetricsGroupSectionComponent,
    FormMetricsItemWidgetComponent,
    FormMetricsCommentsModalComponent,
    FormMetricsPieWidgetComponent,
    FormMetricsBarWidgetComponent,
    FormMetricsThermometerWidgetComponent,
    FormMetricsBinaryThermometerWidgetComponent,
    FormMetricsCommentsWidgetComponent,
    FormMetricsTemporalWidgetComponent,
    FormMetricsChartLegendComponent,
    NgApexchartsModule,
    TacticalDimensionTableComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule { }
